import { OrderType } from "@/constants/enum";
import { TableInfoItem } from "./tableInfoItem";
import { formatOrderTypeToString } from "@/utils/scanToOrderUtils";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export interface ScanToOrderCartTableInfoProps {
  tableName: string;
  orderType: OrderType;
}

export const ScanToOrderCartTableInfo = ({
  tableName,
  orderType,
}: ScanToOrderCartTableInfoProps) => {
  const t = useTranslations("ScanToOrderCartTableInfo");
  const orderTypeText = formatOrderTypeToString(orderType);
  return (
    <div
      data-testid={applyDataTestId(pom.scanToOrder.scanToOrderCartTableInfo)}
      className="flex pb-4 mx-4 flex-row columns-2 justify-normal"
    >
      <TableInfoItem item={t("orderType")} value={orderTypeText} />
      <TableInfoItem item={t("tableNumber")} value={tableName} />
    </div>
  );
};
